export const LISTING_PRODUCT="LISTING_PRODUCT"
export const LISTING_PRODUCT_SUCCESS="LISTING_PRODUCT_SUCCESS"
export const LISTING_PRODUCT_FAILED="LISTING_PRODUCT_FAILED"
export const ADDING_PRODUCT="ADDING_PRODUCT"
export const ADDING_PRODUCT_SUCCESS="ADDING_PRODUCT_SUCCESS"
export const ADDING_PRODUCT_FAILED="ADDING_PRODUCT_FAILED"
export const DELETING_PRODUCT="DELETING_PRODUCT"
export const DELETING_PRODUCT_SUCCESS="DELETING_PRODUCT_SUCCESS"
export const DELETING_PRODUCT_FAILED="DELETING_PRODUCT_FAILED"
export const UPDATING_PRODUCT="UPDATING_PRODUCT"
export const UPDATING_PRODUCT_SUCCESS="UPDATING_PRODUCT_SUCCESS"
export const UPDATING_PRODUCT_FAILED="UPDATING_PRODUCT_FAILED"
export const INFO_PRODUCT="INFO_PRODUCT"
export const INFO_PRODUCT_SUCCESS="INFO_PRODUCT_SUCCESS"
export const INFO_PRODUCT_FAILED="INFO_PRODUCT_FAILED"
export const RESET_PRODUCT_EDIT_STATE = "RESET_PRODUCT_EDIT_STATE"
export const RESET_PRODUCT_ADD_STATE = "RESET_PRODUCT_ADD_STATE"
export const RESET_PRODUCT_INFO_STATE = "RESET_PRODUCT_INFO_STATE"